import { Article } from '../../types/article';
import { bestEroticStoriesForWomen } from './best-erotic-stories-for-women';
import { elegantEroticaGuide } from './elegant-erotica-guide';
import { dailyEroticStories } from './daily-erotic-stories';
import { romanticErotica } from './romantic-erotica';
import { europeanEroticStories } from './european-erotic-stories';
import { lesbianEroticaLGBTQ } from './lesbian-erotica-lgbtq';
import { bdsmEroticaBeginners } from './bdsm-erotica-beginners';
import { eroticStoriesCouples } from './erotic-stories-couples';
import { whyIStartedWriting } from './why-i-started-writing';

export const articles: Article[] = [
  bestEroticStoriesForWomen,
  elegantEroticaGuide,
  dailyEroticStories,
  romanticErotica,
  europeanEroticStories,
  lesbianEroticaLGBTQ,
  bdsmEroticaBeginners,
  eroticStoriesCouples,
  whyIStartedWriting,
  ];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find(article => article.slug === slug);
};

export const getAllArticles = (): Article[] => {
  return articles.sort((a, b) => b.publishDate.localeCompare(a.publishDate));
};
